var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t('Device inputs')))]),_c('ul',_vm._l((_vm.inputs),function(value,key){return _c('JsonItem',{key:key,attrs:{"itemKey":key,"itemValue":value}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }